module.exports = __webpack_public_path__ + "static/media/owner-yes-active.e7496de7.png";